<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Admins</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Admins
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Admins</h4>
                </div>

                <div class="card-body">
                    <div class="search-container pb-3">
                        <div class="row">
                            <div class="col-md-4 d-flex align-items-center">
                                <input id="search-term" type="text"
                                       class="table-search form-control form-control-sm"
                                       placeholder="🔍 Search this table"
                                       v-model="searchTerm"
                                       @keyup="paginatedData"
                                >
                            </div>
                        </div>
                    </div>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allAdmins"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'email'">
                                <a :href="`mailto:${props.row.email}`">{{ props.row.email }}</a>
                            </span>
                            <span v-else-if="props.column.label === 'Name'">
                               <a :href="route('admin.admins.show', props.row.id)">{{
                                       props.row.first_name + ' ' + props.row.last_name
                                   }}</a>
                            </span>
                            <span v-else-if="props.column.field === 'action'">
                                <span class="dropdown">
											<a id="btnSearchDrop2" data-toggle="dropdown" aria-haspopup="true"
                                               aria-expanded="false" class="dropdown-toggle dropdown-menu-right"><i
                                                class="fa fa-ellipsis-v"></i></a>
											<span aria-labelledby="btnSearchDrop2"
                                                  class="dropdown-menu mt-1 dropdown-menu-right"
                                                  x-placement="bottom-end"
                                                  style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 19px, 0px);"
                                                  x-out-of-boundaries="">
												<a :href="route('admin.admins.edit', props.row.id)"
                                                   class="dropdown-item edit"><i class="feather icon-edit-2"></i>
													Edit</a>
                                                 <a href="#" @click.prevent="showAlert(props.row.id, 'disable')" class="dropdown-item delete"><i
                                                     class="feather icon-unlock"></i> Disable MFA</a>
                                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger delete"><i
                                                    class="feather icon-trash-2"></i> Delete</a>
											</span>
										</span>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Admin'},
    props: ['admins'],
    layout: Layout,

    data: () => ({
        filter: {},
        isLoadingFilter: false,
        allAdmins: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Name', field: 'name'},
            {label: 'Email', field: 'email'},
            {label: 'Role', field: 'role'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
        searchTerm: '',
    }),
    mounted() {
        this.allAdmins = this.admins.data;
        this.totalRecords = this.admins.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.admins.index') +
                    `?q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}`;
                let {data: {data: {admins}}} = await axios.get(url);

                this.totalRecords = admins.total;
                this.paginationOptions.perPage = admins.per_page;
                this.allAdmins = admins.data
            } catch (e) {
                console.log(e);
            }
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
        deleteAccount(accountId) {
            try {
                let routeName = 'admin.admins.delete';

                this.$inertia.post(route(routeName, accountId), {
                    '_method' : 'delete'
                }, {
                    preserveScroll: true,
                    onSuccess: (response) => {
                        if (! response.props.flash.error) {
                            this.paginatedData();
                        }
                    },
                });
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },
        disableMfa(accountId) {
            try {
                let routeName = 'admin.admins.disable-mfa';

                this.$inertia.post(route(routeName, accountId), {} , {
                    preserveScroll: true,
                    onSuccess: (response) => {
                        if (! response.props.flash.error) {
                            this.paginatedData();
                        }
                    },
                });
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },
        showAlert(accountId, type = 'delete') {
            let vInstance = this;

            this.$swal.fire({
                title: type === 'delete' ? "Are you sure you want to delete this Admin?" : "Are you sure you want to disable MFA for this Admin?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: type === 'delete' ? "Yes, delete it!" : "Yes, disable it!",
                confirmButtonClass: "btn btn-primary mr-3",
                cancelButtonClass: "btn btn-danger ml-1",
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    if (type === 'delete') {
                        vInstance.deleteAccount(accountId)
                    } else {
                        vInstance.disableMfa(accountId)
                    }
                }
            });
        },
    }
}
</script>
